import configSiteUrls from '../../../configs/configSiteUrls';

export function gerarUrlCapa(filename: string, tipo: string) {
  const url = `${configSiteUrls.SITE_ANEXO_URL_IMAGEM}${encodeURIComponent(filename)}&_ts=b${Date.now()}&tipo=${tipo}`; 
  return url;
}
